// extracted by mini-css-extract-plugin
export default {"container":"style_container__ij0Ew","text":"style_text__4KlYA","closeBtn":"style_closeBtn__LIyiu"};